import React, { createContext } from 'react';

export const PlanoContext = createContext({});
